import { ApiService } from '../apiService'
import type { ReviewBounds, ReviewPinDto } from '@features/reviewMode/reviewMode'

/**
 * Moderator review mode (Backlog 058). Both routes answer 403 to anyone without the global
 * Moderator or Admin role, so the client only calls them for those users.
 */
export const reviewModeApi = {
  /** Adventures needing moderation inside the box. Never cached publicly (no-store). */
  getReviewPins: (bounds: ReviewBounds) =>
    ApiService.get<ReviewPinDto[]>('/api/adventures/map/review', {
      west: bounds.west,
      south: bounds.south,
      east: bounds.east,
      north: bounds.north,
    }),

  /** The audit record of entering or leaving review mode. 204. */
  setReviewMode: (on: boolean) =>
    ApiService.post<void>('/api/me/review-mode', { on, client: 'web' }),
}
